export default __webpack_public_path__ + "static/event1-602104a017abacbf07ecbc0f7a27b30e.jpg";